import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-zoom-image',
  templateUrl: './zoom-image.component.html',
  styleUrls: ['./zoom-image.component.scss'],
})
export class ZoomImageComponent  implements OnInit {

   @Input() focusMediaValue: string = "";
  @Output() closeClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  closeZoomImage() {
    this.closeClick.emit();
  }

}
